import * as cornerstone from 'cornerstone-core';

const metaData = cornerstone.metaData;

export default metaData;



// WEBPACK FOOTER //
// ./metaData.js